module.exports = __webpack_public_path__ + "static/media/guidance_icon_dei.5d668ea3.png";